export default "/images/vendor/flag-icons/flags/4x3/aq.svg?2405e38d3ce9174eee6079dcd242abbe";